import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';

const apiUrl = GlobalConstants.apiURL

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private http:HttpClient, private sharedapi:SharedService) { }

  updateProductDetail(leadId,OpdData)
  {
      let lead_id = leadId;
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-product-detail/'+lead_id,OpdData,{headers:webheader})
  }

  getProductBookingDetail(lead_id)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-product-booking-details/'+lead_id,{headers:webheader})
  }

  amountReceivedDeleted(product_Payment_Id) {
    let webheader = this.sharedapi.getHeaders();
    return this.http.delete(apiUrl+'delete-product-payment/'+product_Payment_Id,{headers:webheader})
  }

  uploadProductFile(lead_id,formData)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'upload-product-docs/'+lead_id,formData,{headers:webheader})
  }

  deleteProductFile(fileId)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.delete(apiUrl+'delete-product-file/'+fileId,{headers:webheader})
  }

  getProducts(pageno,limit,qstring)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-products/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  productDetailDeleted(product_Detail_Id) {
    let webheader = this.sharedapi.getHeaders();
    return this.http.delete(apiUrl+'delete-product-detail/'+product_Detail_Id,{headers:webheader})
  }

  getFullProductHistory(product_booking_id)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-full-product-history/'+product_booking_id,{headers:webheader})
  }

  viewProductDetails(product_id)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'view-product/'+product_id,{headers:webheader})
  }

  uploadProductCsv(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'import-products-csv',data,{headers:webheader})
  }

  productOrderSubmitDetail(productData)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'product-order-detail',productData,{headers:webheader})
  }

  productTracking(product_booking_id)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'product-tracking/'+product_booking_id,{headers:webheader})
  }

  getAddressUsingPincode(pincode)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'product-address-using-pincode/'+pincode,{headers:webheader})
  }

  getOrderdProductData(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'get-Orderd-Product-Data',data,{headers:webheader})
  }

  updateProductOrderDetail(productData)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-product-order-detail',productData,{headers:webheader})
  }

  uploadProductCsvWithLeads(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'import-products-csv-with-leads',data,{headers:webheader})
  }

  getAllProductsList()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-all-product-list',{headers:webheader})
    }

}
